var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-loader",class:[_vm.isLoading && 'global-loader--loading']},[_c('div',{staticClass:"global-loader__loader"},[_c('img',{attrs:{"src":require('~/assets/img/VVV-logo.svg'),"width":"64","height":"58","alt":"logo"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }